import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-senior-citizen-quote',
  templateUrl: './senior-citizen-quote.component.html',
  styleUrls: ['./senior-citizen-quote.component.css']
})
export class SeniorCitizenQuoteComponent implements OnInit {

  planValue = 2000;
  seniorAge: string;
  sumInsured:string;
  familyDef:string;
  CarePremiumAmount:string;
  specialCarePremiumAmount:string;
  starPremiumAmount:number;
  careData: any = [];
  starData: any = [];
  careSpecial:any=[];
  showCareDetails:boolean;
  careButtonName:string;
  starButtonName:string;
  showStarDetails:boolean;
  showCareSpecialDetails:boolean;
  careSpecialButtonName:string;
  //for disabling div  in production
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) {
     }


  ngOnInit() {
    if(localStorage.getItem('sumAssured')=='500000')
     this.sumInsured = '5 Lakhs'
    else if(localStorage.getItem('sumAssured')=='300000')
     this.sumInsured = '3 Lakhs'
    else{
      this.sumInsured = '5 Lakhs'
    } 
    this.familyDef = localStorage.getItem('seniorFamdef') || 'Self Only';
    this.careButtonName='View Details';
    this.showCareDetails=false;
    this.starButtonName='View Details';
    this.showStarDetails=false;
    this.careSpecialButtonName='View Details';
    this.showCareSpecialDetails=false;
    this.seniorCitizenCalcCall()
  

    this.careSpecial = [
      {name:'Sum Inusred', value: this.sumInsured},
      {name:'Cover Opted for', value:this.familyDef},
      {name:'Inpatient care coverage up to the full limit of sum insured', value:'Tick'},
      {name:'Day Care Treatment Coverage up to the full limit of sum insured', value:'Tick'},
      {name:"Cover for Hospital's Normal Room Rent Expenses", value:'Tick'},
      {name:"Cover for Hospital's ICU Room Rent Expenses", value:'Tick'},
      {name:'Pre-existing diseases coverage from 3rd year:', value:'Tick'},
      {name:'Named Ailments (as defined in group care 360 product) coverage from 3rd Year', value:'Tick'},
      {name:'Cover for Pre-hospitalisation Medical Expenses for 30 days', value:'Tick'},
      {name:'Cover for Post hospitalisation Medical Expenses for 60 days', value:'Tick'},
      {name:'Cover for Domestic Road Ambulance up to Rs. 3,000 per hospitalisation', value:'Tick'},
      {name:'30 Days Waiting Period is applicable(except for injuries/accident)', value:'Tick'},
      {name:'Free e-consultation-health service', value:'Tick'},
    ]
    
   }

   seniorCitizenSpecialCalc(){
    let sumAssured, count;
    if(this.sumInsured=='5 Lakhs'){
       sumAssured = 500000
    }else if(this.sumInsured=='3 Lakhs'){
       sumAssured = 300000
    }
    else{
      sumAssured = ""
    }
    localStorage.setItem("sumAssured",sumAssured)
    if(this.familyDef=='Self Only'){
      count = 1
    }else if(this.familyDef=='Self and Spouse'){
      count = 2
    }
    else{
     count = 0
    }

    let data = {
      age: localStorage.getItem("seniorAge"), 
      member_count: count,
      sum_insured: sumAssured
    }
    this.serviceURLService.callSeniorCitizenCareCalc(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {   
        console.log(successData, "care")
        this.specialCarePremiumAmount = !Number.isNaN(Number(successData.premium_amt))?Math.round(successData.premium_amt):successData.premium_amt;
    }, errorData => {
      
    })

    }

   showMoreCareDetails(){
    this.showCareDetails=!this.showCareDetails;
    this.careButtonName=this.showCareDetails?'Hide Details':'View Details';
   }

   showMoreCareSpecialDetails(){
    this.showCareSpecialDetails=!this.showCareSpecialDetails;
    this.careSpecialButtonName=this.showCareSpecialDetails?'Hide Details':'View Details';
   }

   showMoreStarDetails(){
    this.showStarDetails=!this.showStarDetails;
    this.starButtonName=this.showStarDetails?'Hide Details':'View Details';
   }

   redirectToThankYouPage(){
    let data = {
      mobile: localStorage.getItem("mobileNumber"),
      prospectId : "",
      rmId : "",
      product : 113,
      email : localStorage.getItem("email"),
      name : localStorage.getItem("name"),
      company : "",
      location : "",
      designation : "",
      comment : "",
      partnerId : "",
      channel : "Notify-App",
      leadSource : "Notify-App",
      googleClickID : "",
      couponCode : ""
    }
    // var prospectIdFHI = localStorage.getItem('prospectIdFHI');
    
      this.serviceURLService.saveFHIProspect(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
        // // console.log("Prospect created successfully ",successData)
        //   this.prospectIdFHI = successData.data.prospectId;
        //   localStorage.setItem("prospectIdFHI", this.prospectIdFHI)
      }, errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if(errorData.error.status === 403){
          // this.error = errorData.error.message;
        }
      })
    
    this.router.navigate(['/thank-you']);
   }

   redirectToCareProposalForm(){
    this.router.navigate(['/thank-you']);
    // console.log("redirected to Care Proposal Form")
    // if(this.specialCarePremiumAmount){
    //   localStorage.setItem("premiumAmountSenior", this.specialCarePremiumAmount)
    //   this.router.navigate(['/senior-citizen-proposal-form']);
    // }
    // else{
    //   this.router.navigate(['/thank-you']);
    // }
   }

   seniorCitizenCalcCall(){
    
     localStorage.setItem("seniorFamdef",this.familyDef)
    this.seniorCitizenSpecialCalc()
     let data = {
      XLEW_1_3_5: localStorage.getItem("seniorAge"),
      XLEW_2_2_5: this.sumInsured,
      XLEW_2_2_9: this.familyDef,
      XLEW_2_6_4: "Religare Health Insurance",
      XLEW_2_6_8: "Star Health Insurance",
      XLEW_2_11_2: "Pre hospitalisation expenses",
      XLEW_2_12_2: "Post hospitalisation expenses",
      XLEW_2_13_2: "Day-care Procedures",
      XLEW_2_14_2: "OPD Treatment",
      XLEW_2_15_2: "Restoration Benefit",
      XLEW_2_16_2: "Health Check up",
      XLEW_2_17_2: "Co-Pay",
      XLEW_2_18_2: "Sub-limits on Normal Room Rent",
      XLEW_2_19_2: "Sub-limits on ICU Room Rent",
      XLEW_2_20_2: "Waiting Period for specific diseases",
      XLEW_2_21_2: "Waiting period for pre-existing diseases",
      XLEW_2_22_2: "Ambulance Charges",
      XLEW_2_23_2: "Pre policy Medical Check up Required",
      XLEW_2_24_2: "Lifelong Renewability",
     }

     this.careSpecial = [
      {name:'Sum Inusred', value: this.sumInsured},
      {name:'Cover Opted for', value:this.familyDef},
      {name:'Inpatient care coverage up to the full limit of sum insured', value:'Tick'},
      {name:'Day Care Treatment Coverage up to the full limit of sum insured', value:'Tick'},
      {name:"Cover for Hospital's Normal Room Rent Expenses", value:'Tick'},
      {name:"Cover for Hospital's ICU Room Rent Expenses", value:'Tick'},
      {name:'Pre-existing diseases coverage from 3rd year:', value:'Tick'},
      {name:'Named Ailments (as defined in group care 360 product) coverage from 3rd Year', value:'Tick'},
      {name:'Cover for Pre-hospitalisation Medical Expenses for 30 days', value:'Tick'},
      {name:'Cover for Post hospitalisation Medical Expenses for 60 days', value:'Tick'},
      {name:'Cover for Domestic Road Ambulance up to Rs. 3,000 per hospitalisation', value:'Tick'},
      {name:'30 Days Waiting Period is applicable(except for injuries/accident)', value:'Tick'},
      {name:'Free e-consultation-health service', value:'Tick'},
    ]
     

    this.serviceURLService.callSeniorCitizenCalc(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {   
        
      this.CarePremiumAmount = !Number.isNaN(Number(successData.XLEW_2_8_4))?Math.round(successData.XLEW_2_8_4):successData.XLEW_2_8_4;
      this.starPremiumAmount = !Number.isNaN(Number(successData.XLEW_2_8_8))?Math.round(successData.XLEW_2_8_8):successData.XLEW_2_8_8;
      this.careData = [
        {name:'Sum Inusred', value:successData.XLEW_2_2_5},
        {name:'Cover Opted for', value:successData.XLEW_2_2_9},
        {name:'Day-care Procedures', value:successData.XLEW_2_13_4},
        {name:'Co-Pay', value:successData.XLEW_2_17_4},
        {name:'Pre hospitalisation expenses', value:successData.XLEW_2_11_4},
        {name:'OPD Treatment', value:successData.XLEW_2_14_4},
        {name:'Post hospitalisation expenses', value:successData.XLEW_2_12_4},
        {name:'Pre policy Medical Check up Required', value:successData.XLEW_2_23_4},
        {name:'Sub-limits on Normal Room Rent', value:successData.XLEW_2_18_4},
        {name:'Restoration Benefit', value:successData.XLEW_2_15_4},
        {name:'Sub-limits on ICU Room Rent', value:successData.XLEW_2_18_4},
        {name:'Health Check up', value:successData.XLEW_2_16_4},
        {name:'Waiting Period for specific diseases', value:successData.XLEW_2_20_4},
        {name:'Waiting period for pre-existing diseases', value:successData.XLEW_2_21_4},
        {name:'Ambulance Charges', value:successData.XLEW_2_22_4},
        {name:'Lifelong Renewability', value:successData.XLEW_2_24_4},
      ]
       
      this.starData = [
        {name:'Sum Inusred', value:successData.XLEW_2_2_5},
        {name:'Cover Opted for', value:successData.XLEW_2_2_9},
        {name:'Pre hospitalisation expenses', value:successData.XLEW_2_11_8},
        {name:'Post hospitalisation expenses', value:successData.XLEW_2_12_8},
        {name:'Day-care Procedures', value:successData.XLEW_2_13_8},
        {name:'Co-Pay', value:successData.XLEW_2_17_8},
        {name:'OPD Treatment', value:successData.XLEW_2_14_8},
        {name:'Sub-limits on Normal Room Rent', value:successData.XLEW_2_18_8},
        {name:'Restoration Benefit', value:successData.XLEW_2_15_8},
        {name:'Sub-limits on ICU Room Rent', value:successData.XLEW_2_18_8},
        {name:'Health Check up', value:successData.XLEW_2_16_8},
        {name:'Waiting Period for specific diseases', value:successData.XLEW_2_20_8},
        {name:'Waiting period for pre-existing diseases', value:successData.XLEW_2_21_8},
        {name:'Ambulance Charges', value:successData.XLEW_2_22_8},
        {name:'Pre policy Medical Check up Required', value:successData.XLEW_2_23_8},
        {name:'Lifelong Renewability', value:successData.XLEW_2_24_8},
      ]    
    }, errorData => {
      
    })
   }
 
}